const monetary = {
    /**
     * 金額數字格式 轉 為中文格式
     * 25400 -> 2.54萬
     * 5400 -> 5.4千元
     * 
     * @param {Number} value 
     * @returns {String}
     */
    convertToChineseUnit: (value) => {

        if (value > 9999) {
            return (value / 10000) + '萬';
        } else if (value > 999) {
            return (value /1000) + '千元';
        } else {
            return value + '元';
        }
    },
    /**
     * 金額數字格式 轉 為英語格式（千分位）
     * 15000 -> 15,000
     * 
     * @param {Number} value 
     * @returns {String}
     */
    convertToLocaleString: (value) => {
        return value ? value.toLocaleString('en-US') : '';
    }
};

export default monetary;